import React, {useState, useEffect} from 'react'
import "./Post.css"
import Avatar from '@material-ui/core/Avatar';
import { db } from './firebase';
import firebase from "firebase";

function Post({postId, user, username, caption, imageUrl}) {
    const [comments, setComments] = useState([]);
    const [comment, setComment] = useState('');

    useEffect(() => {
        const unsubscribe = db.collection("posts").doc(postId).collection("comments").orderBy('timestamp', 'desc').onSnapshot((snapshot)=> {
            setComments(snapshot.docs.map((doc)=> doc.data()));
        });
        return () => {
            unsubscribe();
        };
    }, [postId]);

    const postComment = (event) => {
        event.preventDefault();
        db.collection("posts").doc(postId).collection("comments").add({
            text: comment,
            username: user.displayName,

            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        });
        setComment('');
    }
    return (
        <div className="post">

            {/* Header -> avatar + username*/}
            <div className="post__header">
                <Avatar
                className="post__avatar" 
                src = "/static/images/avatar/1.jpg/>" alt="Yash"/>
                <h3> {username}</h3>
            </div>

            {/* image */}
            <img
                className="post__image"
                src={imageUrl}
                alt="Post" 
            />
            {/* username + caption */}
            <p className="post__text"><strong>{username}</strong>: {caption}</p>

            {/* Comments */}
            <div className="post__comments">
                {
                    comments.map((comment) => (
                        <p>
                            <b>{comment.username}</b> {comment.text}
                        </p>
                    ))
                }
            </div>

            
            {/* Comment Box */}
            {
                user && (
                    <form className="post__commentBox">
                <input
                    className="post__input"
                    type="text"
                    placeholder = "Add a comment..."
                    value = {comment}
                    onChange = {(e) => setComment(e.target.value)}
                />
                <button
                    className="post__button"
                    disabled={!comment}
                    type= "submit"
                    onClick={postComment}
                >Post</button>
            </form>
                )
            }
            
        </div>
    )
}

export default Post
